"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _renderItem = _interopRequireDefault(require("./RenderItem"));
var _measure = _interopRequireDefault(require("./Measure"));
var _store = _interopRequireDefault(require("./store"));
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var defaultprops = {
    windowSize: 3,
    direction: 'vertical',
    style: {}
};
var LazyList = /*#__PURE__*/ (0, _react).forwardRef(function(props, ref) {
    var containerRef = (0, _react).useRef(null);
    var _$ref = _slicedToArray((0, _react).useState([]), 2), measureItems = _$ref[0], setMeasureItems = _$ref[1];
    var _$ref1 = _slicedToArray((0, _react).useState(null), 2), renderData = _$ref1[0], setRenderData = _$ref1[1];
    var _$ref2 = _slicedToArray((0, _react).useState('100%'), 2), size = _$ref2[0], setSize = _$ref2[1];
    var getItemLayout = (0, _react).useCallback(function(item, index) {
        if (props.getItemLayout) return props.getItemLayout(item, index);
        return new Promise(function(resolve) {
            setMeasureItems(function(items) {
                return _toConsumableArray(items).concat([
                    {
                        item: item,
                        index: index,
                        callback: function(dimensions) {
                            resolve(dimensions);
                        }
                    }
                ]);
            });
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.getItemLayout
    ]);
    var _obj;
    var store = (0, _react).useRef(new _store.default(props.data, (_obj = {
        name: props.name,
        windowSize: props.windowSize,
        direction: props.direction,
        onEndReached: props.onEndReached,
        getItemLayout: getItemLayout,
        onRenderUpdate: function(data) {
            setRenderData(data);
        }
    }, _defineProperty(_obj, props.estimatedItemSize ? 'estimatedItemsSize' : '', props.estimatedItemSize), _defineProperty(_obj, props.initialItemsToRender ? 'initialItemsToRender' : '', props.initialItemsToRender), _obj)));
    (0, _react).useImperativeHandle(ref, function() {
        return {
            render: function() {
                store.current.calculateVisibleItems(true);
            },
            setSize: function(width) {
                setSize(width);
            }
        };
    });
    (0, _react).useEffect(function() {
        store.current.setItems(props.data);
    }, [
        props.data
    ]);
    (0, _react).useEffect(function() {
        if (!containerRef.current) return;
        var _store1 = store.current;
        if (!props.name) {
            // We hebben een unieke naam nodig ivm caching van de size van de items
            // Dit merk je als je de pagina verlaat en weer terug komt (met back van browser)
            // Dan is de cache nog aanwezig en worden de items niet opnieuw gemeten
            console.error("LazyList: a unique name is required");
            return;
        }
        if (props.estimatedItemSize === undefined && props.initialItemsToRender === undefined) {
            console.error("LazyList: estimatedItemSize or initalItemsToRender is required");
            return;
        }
        if (props.scrollerClass) {
            var root = containerRef.current;
            while(root && !root.classList.contains(props.scrollerClass))root = root.parentElement;
            if (!root) root = window;
            _store1.mount(root, containerRef.current);
        } else _store1.mount(window, containerRef.current);
        return function() {
            _store1.unmount();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var lazyListStyle = _objectSpread({
        position: 'relative'
    }, props.style);
    if (renderData === null || renderData === void 0 ? void 0 : renderData.sumItemSize) {
        if (props.direction === 'vertical') {
            lazyListStyle.width = size;
            lazyListStyle.height = renderData === null || renderData === void 0 ? void 0 : renderData.sumItemSize;
        } else {
            lazyListStyle.height = size;
            lazyListStyle.width = renderData === null || renderData === void 0 ? void 0 : renderData.sumItemSize;
        }
    }
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: "lazylist",
        style: lazyListStyle,
        ref: containerRef
    }, renderData === null || renderData === void 0 ? void 0 : renderData.items.map(function(item) {
        return /*#__PURE__*/ _react.default.createElement(_renderItem.default, {
            key: item.item.key,
            item: item,
            direction: props.direction,
            store: store.current
        }, props.renderItem(item.item, item.index));
    }), measureItems.map(function(item) {
        return /*#__PURE__*/ _react.default.createElement(_measure.default, {
            key: "measure-" + item.item.key,
            onMeasure: function(layout) {
                // Verwijder item uit de lijst
                setMeasureItems(function(items) {
                    return items.filter(function(i) {
                        return i.item.key !== item.item.key;
                    });
                });
                item.callback(layout);
            }
        }, props.renderItem(item.item, item.index));
    }), /*#__PURE__*/ _react.default.createElement("style", null, "\n      .lazylist-item {\n        position: absolute;\n        opacity: 0;\n        transition: opacity .3s ease-out;\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n      }\n    "));
});
LazyList.displayName = 'LazyList';
LazyList.defaultProps = defaultprops;
var _default = LazyList;
exports.default = _default;
